import styled from "styled-components";

const ChangelogWrapper = styled.div`
  h1,
  h2 {
    display: flex;
    align-items: baseline;
    color: ${(props) => props.theme.colors.neutral[500]};
    ${(props) => props.theme.typography[500]}
    font-weight: ${(props) => props.theme.fontWeights.normal};
    margin-top: ${(props) => props.theme.space[600]};
    margin-bottom: ${(props) => props.theme.space[450]};

    a {
      ${(props) => props.theme.typography[700]}
      font-weight: ${(props) => props.theme.fontWeights.bold};
      margin-right: ${(props) => props.theme.space[350]};
      transform: translatey(2px);
    }
  }

  h1#change-log {
    display: none;

    + p {
      display: none;
    }
  }

  h3 {
    ${(props) => props.theme.typography[400]}
    font-weight: ${(props) => props.theme.fontWeights.bold};
    margin-top: ${(props) => props.theme.space[350]};
    margin-bottom: ${(props) => props.theme.space[350]};
  }
`;

export default ChangelogWrapper;
